/**
 * ROUND n/N in every game view: the lobby kit's short pill in the table's tint with the count in gold (owner 23.9.2026:
 * "pilleri, joka menee sen värisävyn mukaan ja toi round 1 kautta 1 … eihän se voi mennä laidasta laitaan"). One element,
 * placed by left/top/width/height; the word at the chip role, centred. Pure CSS (OD-036).
 */
import { KitPiece } from './LobbyKit';

export const ROUND_PILL = { id: 'round.pill', piece: 'pill.short.png', render: '3-slice' as const, tint: 'cyan', z: 20, slicePx: { left: 70, right: 70, top: 0, bottom: 0 }, x: 16, y: 20, w: 252, h: 76 };   // Codex 23.9.2026: 252 wide, the word at 26 leaves 31 px at each side

export function RoundPill({ no, count }: { no: number; count: number }) {
  return (
    <>
      <KitPiece e={ROUND_PILL} cls="bd-kit" />
      <div class="bd-round2" style={{ left: ROUND_PILL.x, top: ROUND_PILL.y + 1, width: ROUND_PILL.w, height: ROUND_PILL.h }} data-testid="round-pill"><span>ROUND <b class="gold">{no}/{count}</b></span></div>   {/* the word 1 down, the pill in place (owner 24.9.2026) */}
    </>
  );
}
